import type { Direction, Movement } from '@studio/models/ptz';
import { toDirection, toMovement } from '@studio/models/ptz';
import type { T_Maybe } from '@tryiris-ai/js-types';
import type { SyntheticEvent } from 'react';

/** @internal */
export const getTargetIntent = (event: SyntheticEvent): [T_Maybe<Direction>, T_Maybe<Movement>] => {
  const { target } = event;

  const { dataset } = (<HTMLElement>target).closest('button') ?? {};

  return [toDirection(dataset?.direction), toMovement(dataset?.movement)];
};
